import 'simplebar/dist/simplebar.min.css';
import { forwardRef, type ComponentProps } from 'react';
import SimpleBar from 'simplebar-react';
import { styled } from '@mui/system';

const ScrollbarRoot = styled(SimpleBar)``;

export type ScrollbarProps = ComponentProps<typeof SimpleBar>;

export const Scrollbar = forwardRef<any, ScrollbarProps>((props, ref) => {
  return <ScrollbarRoot ref={ref} {...props} />;
});

Scrollbar.displayName = 'Scrollbar';
